import { Injectable } from "@angular/core";

import { Subject } from "rxjs";
import { FlcBaseLayer } from "./flc-base-layer.model";
import { FlcControlLayer } from "./flc-control-layer.model";

@Injectable()
export class LayerSwitcherService {

  selectedBaseLayer: FlcBaseLayer;
  selectedFlcControlLayer: FlcControlLayer;
  visibleParentLayer: boolean = true;
  showLegendsButton: boolean = false;
  showMeasureButton: boolean = true;

  baseLayers: FlcBaseLayer[] = [];

  public setSelectedBaseLayer = new Subject<FlcBaseLayer>();
  public setSelectedFlcControlLayer = new Subject<FlcControlLayer>();
  public layerchanged = new Subject<FlcControlLayer>();
  public sectionClickedOnMap = new Subject<string>();
  public closeLayerSwitcherOverlay = new Subject<void>();
  public resizeMap = new Subject<void>();
  public setVisibleParentLayer = new Subject<boolean>();
  public setVisibleLegends = new Subject<boolean>();
  public setVisibleMeasure = new Subject<boolean>();

  public addNewSectionLayer = new Subject<string>();

  public setSelectedSection = new Subject<string>();
  public setLogMessage = new Subject<string>();

  public addRasterTiffLayer = new Subject<string>();

  public setFlcControlLayers = new Subject<FlcControlLayer[]>();

  constructor() {}

  selectSection(id: string)
  {
    this.setSelectedSection.next(id);
  }

  selectLogMessage(id: string)
  {
    this.setLogMessage.next(id);
  }

    mapSectionSelect(id: string)
  {
    this.sectionClickedOnMap.next(id);
  }

  toLayerChanged(l: FlcControlLayer)
  {
    this.layerchanged.next(l);
  }

  preSetSelectedBaseLayer(bl: FlcBaseLayer)
  {
    this.selectedBaseLayer = bl;
    this.setSelectedBaseLayer.next(bl);
  }

  preSetSelectedFlcRasterLayer(flc: FlcControlLayer)
  {
    this.selectedFlcControlLayer = flc;
    this.setSelectedFlcControlLayer.next(flc);
  }

  toSetFlcControlLayers(controlLayers: FlcControlLayer[])
  {
    this.setFlcControlLayers.next(controlLayers);
  }

  toCloseLayerSwitcherOverlay()
  {
    this.closeLayerSwitcherOverlay.next();
  }

  toAddSectionLayer(id: string)
  {
    this.addNewSectionLayer.next(id);
  }

  toSetVisibleParentLayer(visible: boolean)
  {
    this.setVisibleParentLayer.next(visible);
  }


  toSetVisibleLegends(visible: boolean)
  {
    this.setVisibleLegends.next(visible);
  }

  toSetVisibleMeasure(visible: boolean)
  {
    this.setVisibleMeasure.next(visible);
  }

  onResizeContainer()
  {
    this.resizeMap.next();
  }

  toAddRasterTiffLayer(rasterId: string)
  {
    this.addRasterTiffLayer.next(rasterId);
  }

  setShowLegendsButton(visible: boolean)
  {
    this.showLegendsButton = visible;
  }

  setShowMeasureButton(visible: boolean)
  {
    this.showMeasureButton = visible;
  }

  getShowLegendsButton()
  {
    return this.showLegendsButton;
  }

  getshowMeasureButton()
  {
    return this.showMeasureButton;
  }
}
